import React from 'react';
import './FocusAreas.css';

// Import suitable icons from the library
import { FaLeaf, FaTractor, FaRecycle, FaIndustry, FaHardHat, FaCar } from 'react-icons/fa';

// Data for our focus areas
const focusData = [
  { icon: <FaLeaf />, title: 'Agri Inputs', subtitle: '(seeds, fertilizers, etc.)' },
  { icon: <FaTractor />, title: 'Farming & Production', subtitle: '' },
  { icon: <FaRecycle />, title: 'Recycling & non-metals', subtitle: '' },
  { icon: <FaIndustry />, title: 'Manufacturing & capital goods', subtitle: '' },
  { icon: <FaHardHat />, title: 'Construction materials & green technologies', subtitle: '' },
  { icon: <FaCar />, title: 'Automotive & Engineering', subtitle: '' },
];

const FocusAreas = () => {
  return (
    <section className="focus-areas-section">
      <div className="focus-areas-container">
        <div className="section-header">
          <h2>Our research focus areas</h2>
          <div className="header-line"></div>
        </div>
        <div className="focus-grid">
          {focusData.map((item, index) => (
            <div key={index} className="focus-item">
              <div className="focus-icon-circle">
                {item.icon}
              </div>
              <h4>{item.title}</h4>
              {item.subtitle && <span>{item.subtitle}</span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FocusAreas;